import { createContext, useState, useEffect } from 'react';
import i18n, {
  getLanguageFromBrowser,
  I18N_MANUAL_STORAGE_KEY,
  I18N_STORAGE_KEY,
} from '../../i18n/index';

export const IntlContext = createContext()

// eslint-disable-next-line react/prop-types
export const IntlContextProvider = ({children}) => {
    
  const [country, setCountry] = useState(null)

  useEffect(() => {
    let isMounted = true

    async function getUserCountry() {
      try {
        const response = await fetch('https://get.geojs.io/v1/ip/country.json')
        const data = await response.json()
        if (isMounted) {
          setCountry(data.country?.toLowerCase() ?? 'br')
        }
      } catch {
        if (isMounted) {
          setCountry('br')
        }
      }
    }

    getUserCountry()

    return () => {
      isMounted = false
    }
  }, [])

  useEffect(() => {
    if (localStorage.getItem(I18N_MANUAL_STORAGE_KEY) === 'true') return

    const language = getLanguageFromBrowser()
    if (i18n.resolvedLanguage === language) return

    i18n.changeLanguage(language)
    localStorage.setItem(I18N_STORAGE_KEY, language)
  }, [])
  

  const value  = {country}

  return( 
    <IntlContext.Provider value={value}>
      {children}
    </IntlContext.Provider>
  )
}
